import React from 'react'
import { NavLink } from "react-router"
import styles from "./productCard.module.css"
import { useBrandFilter } from '../../../hooks/useBrandFilter';

export function ProductCard({ product }) {
    const { engineId } = useBrandFilter()
    return (
        <div className={styles.card}>
            <div className={styles.id}>{product?.item_code}</div>
            <picture className={styles.picture}>
                <img src={product.product_images[0]}
                    alt={product.name_ru}
                    className={styles.img}
                    loading='lazy'
                />
            </picture>
            <NavLink className={styles.link} to={`/product/${product.id}${engineId ? `?engineId=${engineId}` : ''}`}  >{product.name_ru}</NavLink>
            <div className={styles.specifications_container}>
                <p className={styles.specifications}>Характеристики</p>
                <div className={styles.specifications_holder}>
                    {product.product_info.slice(0, 3).map((info) => {
                        return <p key={info.code + info.name}>{info.name} {info.code}</p>
                    })}
                </div>
            </div>
        </div>
    )
}
